import { FormControl, FormControlLabel, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { AttributionFilterOption, DataContext } from "../contexts/DataContext";

export const SideBarAttributionCard = () => {
    const { t } = useTranslation();
    const { attributionFilter, setAttributionFilter } = useContext(DataContext);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value as AttributionFilterOption;
        setAttributionFilter(newValue);
    };

    return (
        <Stack height="230px" overflow="auto">
            <Typography fontSize="16px" mb={2}>
                {" "}
                {t("sideBar.attribution")}
            </Typography>
            <FormControl>
                <RadioGroup value={attributionFilter} name="attribution-group" onChange={handleChange}>
                    {/* "Committed" removed from the selector (Ceren/FH/Rebekah 2026-09-18) -- only
                        No filter / Outstanding remain choosable here. */}
                    {(["noFilter", "outstanding"] as AttributionFilterOption[]).map((option) => (
                        <FormControlLabel
                            key={option}
                            value={option}
                            control={<Radio sx={{ alignSelf: "flex-start", pt: 0.5 }} />}
                            label={
                                <Stack>
                                    <Typography fontSize="14px">{t(`attributionOptions.${option}`)}</Typography>
                                    <Typography fontSize="11px" color="text.secondary" lineHeight={1.3}>
                                        {t(`attributionDescriptions.${option}`)}
                                    </Typography>
                                </Stack>
                            }
                            sx={{ alignItems: "flex-start", mb: 1 }}
                        />
                    ))}
                </RadioGroup>
            </FormControl>
        </Stack>
    );
};
